/* eslint-disable @typescript-eslint/no-explicit-any */
import { DCA_CONSTANTS, PPV5_URL_FORMAT } from '../constants';
import { getToken } from './localeToken';

type LoginState = 'authenticated' | 'remembered';

const getTimezoneOffsetMinutes = () => (typeof window !== 'undefined' ? -new Date().getTimezoneOffset() : 0);

export function targetPayloadRequestV2(
  req: any,
  datalayer: Record<string, unknown> = window?.['dataLayer'] || {},
  mvpOffers: any = window?.['mvpOffers'] || {},
  brandBannerParams: Record<string, unknown>[] = []
) {
  const satellite = window?._satellite;
  const pageHref = window?.location?.href;
  const targetParameters = targetRequestPayload([
    'env_is_prod',
    'env_site_id',
    'env_platform',
    'env_site_name',
    'env_server_id',
    'mr_prof_authentication_state',
    'search_advance_purchase_days',
    'prop_address_city_state_country',
    'search_google_places_destination',
    'country',
    'canBuyPoints',
    'daysSinceJoining',
    'daysToCheckin',
    'miRecentlyViewedProperties',
    'mr_prof_upcoming_stay_consolidated',
    'search_cluster_code',
    'page_url_query_string',
    'cookie_merchViewed',
    'firstTimeUserCopy',
    'rpcCode',
    'offerCode',
    'specialMessage',
    'memState',
    'invokeFlushErrors',
    'device_language_preferred',
    'page_url_path_branch',
    'browser_akamai_loc_country',
    'ensighten_settings',
    'browser_akamai_loc_long',
    'rk_enabled',
    'page_requested_uri',
    'env_img_path',
    'prof_address_state',
    'env_jacket',
    'session_jsession_id',
    'cookie_mi_site',
    'sessionId',
    'mr_isLinkedUser',
    'browser_akamai_loc_lat',
    'env_date_time',
    'mvp_prequal_endpoint',
    'brwsrLang',
    'page_domain_name',
    'cookie_mi_visitor',
    'request_id',
    'page_data_layer_ready',
    'previous_page',
    'browser_akamai_loc_state',
    'mr_prof_cc_all',
    'mr_prof_address_country',
    'browser_akamai_loc_city',
    'mr_prof_nights_to_next_level',
    'mr_prof_points_balance',
    'mr_prof_member_program_level',
    'mvpOffers_source',
    'promoIDsRegistered',
    'promoIDsEligible',
    'mr_prof_rewards_level',
    'mr_prof_address_state',
    'userAgent',
    ...(pageHref?.includes(PPV5_URL_FORMAT) ? ['prop_marsha_code', 'prop_brand_code', 'prop_brand_tier'] : []),
  ]);

  function getIdentitiesObject() {
    const loginState: LoginState = datalayer['memState'] as LoginState;
    const isAuthenticated = loginState === 'authenticated' || loginState === 'remembered';
    if (isAuthenticated && (datalayer['altCustId'] || datalayer['mr_id_alternate'])) {
      return {
        identities: [
          {
            namespace: {
              code: 'altcustid',
            },
            primary: true,
            authenticatedState: DCA_CONSTANTS[loginState],
            id: datalayer['altCustId'] || datalayer['mr_id_alternate'],
          },
        ],
      };
    } else return {};
  }

  function targetRequestPayload(variables: any) {
    const result: any = {};
    const parameters = variables.map((variable: string) => {
      let value: any = ''; // Default value if no valid value found
      const getSatelliteVar = satellite?.['getVar'];
      if (satellite && satellite?.['getVar'] && getSatelliteVar(variable)?.length) {
        value = getSatelliteVar(variable);
      } else if (Array.isArray(datalayer?.[variable]) || typeof datalayer?.[variable] === 'string') {
        value = datalayer[variable];
      }
      if (variable === 'mvpOffers_source' && mvpOffers?.source) {
        value = mvpOffers.source;
      }
      if (variable === 'mr_prof_authentication_state') {
        value = value || 'unauthenticated'; // Set default value 'unauthenticated' if value is falsy
      }
      if (variable === 'userAgent') {
        value = window?.navigator?.userAgent;
      }

      if (variable === 'previous_page') {
        value = value ? value : '';
        datalayer[variable] = value ? value : '';
      }
      result[variable] = value;
      return { name: variable, value: value };
    });
    return parameters;
  }

  /**
   *
   * @returns list of mbox parameters with the required properties
   * NOTE: we dont need to copy & pass parameters for all the mboxes, we can include it once  for all the moboxes
   * i.e., name, localeOfContent, parameters
   */
  function constructMboxPayloadParams() {
    return (req?.mboxParameters as Record<string, string>[])?.map(item => {
      return {
        name: item?.['mboxName'],
        attributes: [
          { name: 'trackingDescription', value: DCA_CONSTANTS.DCA },
          { name: 'trackingContentPosition', value: item?.['mboxName']?.split('-mbox')?.[0] },
          { name: 'trackingDisplayCode', value: item?.['cellCodes'] },
        ],
      };
    });
  }

  const tempPayload: any = {
    localeOfContent: req.locale,
    parameters: [...targetParameters, ...brandBannerParams],
    mboxes: constructMboxPayloadParams(),
    context: {
      channel: 'WEB',
      overrides: {
        target: [
          {
            name: 'propertyToken',
            value: getToken(req?.locale?.replace('_', '-'), String(datalayer?.['env_is_prod']) === 'true'),
          },
        ],
      },
      xdm: {
        placeContext: {
          localTimezoneOffset: getTimezoneOffsetMinutes(),
        },
        web: {
          webPageDetails: {
            URL: window?.location?.href,
          },
          webReferrer: {
            URL: window?.location?.origin,
          },
        },
        ...getIdentitiesObject(),
      },
    },
  };

  return tempPayload;
}
